import { Modal, Button, Form } from 'react-bootstrap';

const DeleteProjectModal = ({
    show,
    onHide,
    onConfirm
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Delete Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-tag mb-4">Are you sure you want to change the status of <strong>Netclues Technologies</strong> from <span className='text-primary'>Active</span> to <span className='text-danger'>Inactive</span> ?</div>
                <Form.Group className='mb-4'>
                    <Form.Label>Type the <strong className='text-danger'>Delete</strong> confirmation text. <span className='text-danger'>*</span></Form.Label>
                    <Form.Control type="text"/>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Reason for status change <span className='text-danger'>*</span></Form.Label>
                    <Form.Control as="textarea" rows={3} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteProjectModal;
